/**
 * Charts
 * @namespace Charts
 */

/* Plugins */
import * as d3 from 'd3';
// import moment from 'moment';

export default class Charts {
    /** 
     * Line Chart 
     * @memberof Charts
     * @param {Object} options options (width, height, marginTop, marginBottom, marginLeft, marginRight, strokeWidth, strokeColor, fillColor, edgeToEdge, hasfill, yAxisLabel, yAxislines, xAxisLines, xAxisLabel  curve)
     * */
    static generateLineChart = ({
        // Declare the chart dimensions and margins.
        width           = 370,
        height          = 200,
        marginTop       = 20,
        marginRight     = 30,
        marginBottom    = 30,
        marginLeft      = 40,
        strokeWidth     = 1,
        strokeColor     = '#3987F0',
        fillColor       = `#3987F0`,
        edgeToEdge      = false,
        hasFillGradient = true,
        yAxisLines      = true,
        yAxisLabel      = true,
        xAxisLines      = false,
        xAxisLabel      = true,
        curve           = d3.curveMonotoneX,
        datas            = null                // array of objects with Date and count properties
        }               = {}) => {

        console.log(marginRight)

          console.log('datas', datas)


        const aapl = datas?.length > 0 ? datas : [
          {
            Date: new Date('2018-01-01'),
            count: 0,
          },
          {
            Date: new Date('2018-02-01'),
            count: 0,
          },
    
          {
            Date: new Date('2018-03-01'),
            count: 0,
          },
    
          {
            Date: new Date('2018-04-01'),
            count: 0,
          },
    
          {
            Date: new Date('2018-05-01'),
            count: 0,
          },
        ];

        
        
    
        // Declare the x (horizontal position) scale.
        const x = d3.scaleUtc(
          d3.extent(aapl, (d) => d.Date),
          [marginLeft , width]
        );
    
        // Declare the y (vertical position) scale.
        const max = d3.max(aapl, (d) => d.count) + d3.max(aapl, (d) => d.count) || 20;
    
        console.log('max max', max);
    
        const y = d3.scaleLinear([0, max], [height - marginBottom, marginTop]);
    
        // Declare the line generator.
        const line = d3
          .line()
          .curve(curve)
          .x((d) => x(d.Date))
          .y((d) => y(d.count));
    
        // Create the SVG container.
        const svg = d3
          .create('svg')
          .attr('viewBox', [0, 0, width, height])
          .attr('width', width)
          .attr('height', height)
          .attr('style', 'max-width: 100%; height: auto; height: intrinsic; ')
          .style('-webkit-tap-highlight-color', 'transparent')
          .style('overflow', 'visible');
    
        // Set the gradient
        svg
          .append('linearGradient')
          .attr('id', 'line-gradient')
          .attr('gradientUnits', 'userSpaceOnUse')
          .attr('x1', 0)
          .attr('y1', y(0))
          .attr('x2', 0)
          .attr('y2', y(max))
          .selectAll('stop')
          .data([
              { offset: '0%', color: '#fffff000' },
              { offset: '100%', color: fillColor },
          ])
          .enter()
          .append('stop')
          .attr('offset', function (d) {
            return d.offset;
          })
          .attr('stop-color', function (d) {
            return d.color;
          });
    
        // Append a path for the line.
        const extendedFunction = () => {
            const  extendedData = [
                {
                    Date: new Date('2017-12-01'),
                    count: 0,
                },
                ...aapl,
                {
                    Date: new Date('2018-06-01'),
                    count: 0,
                },
            ];

            const lineValues = line(extendedData).slice(1);
            const splitedValues = lineValues.split(',');
    
            return `M0,${height},${lineValues},l1000,${
              height - splitedValues[splitedValues.length - 1]
            }`;
        }

        /* Draw Fill */
        const areaGenerator = d3.area()
            .x(function(d) { return x(d.Date); })
            .y0(function() {
                return height - marginBottom
            })
            .y1(function(d) { return y(d.count); })
            .curve(curve);

        if(hasFillGradient) {
            svg
            .append('path')
            .attr('fill', 'url(#line-gradient)')
            .attr('d', () => {
                console.log('aapl', aapl )
                return areaGenerator(aapl)
            });
          }
    
        /* Draw Line */
        svg
          .append('path')
          .attr('stroke', strokeColor)
          .attr('stroke-width', strokeWidth)
          .attr('fill', 'none')
          .attr('d', () => {

          
            if(edgeToEdge) {
                return extendedFunction();
            } 

            /* Default */
            return line(aapl)
           
          });

       
        // Add the x-axis.

        /* Get tick dates and add 1 more month at the end  */
          let tickValues = aapl.map(d => d.Date);

            /**
           * check if tickValues has all same month
           * if so, render data by day
           * otherwise, render data by month
           */
          const isOneMonth = tickValues.every(d => d.getMonth() === tickValues[0].getMonth());
          if(!isOneMonth) tickValues.push(d3.timeMonth.offset(tickValues[tickValues.length - 1], 1));
          
          console.log('tickValues isOneMonth', isOneMonth, tickValues)

        svg
          .append('g')
          .attr('class', 'x axis')
          .attr(
            'transform',
            `translate(0, ${height - (marginBottom)})`
          )
          .call(d3.axisBottom(x)
              .ticks(isOneMonth ? d3.timeDay.every(1) : d3.timeMonth.every(1))
              .tickFormat(isOneMonth ? d3.timeFormat('%d') : d3.timeFormat('%b')))
          .call((g) => g.select('.domain').remove())
          .call((g) => {
            if(!xAxisLines) {
                g.selectAll('.tick line').remove()
            }
          })
          .call((g) => {
            if(!xAxisLabel) {
                g.selectAll('text').remove()
            } else {
                g.selectAll('text').attr('class', 'text-gray-1')
            }
          });
    
        // Add the y-axis, remove the domain line, add grid lines and a label.
        svg
            .append('g')
            .attr('class', 'y axis')
            .attr('transform', `translate(${marginLeft},0)`)
            .call(d3.axisLeft(y).ticks(3))
            .call((g) => g.select('.domain').remove())
            .call((g) => {
                if(!yAxisLabel) {
                    g.selectAll('text').remove()
                } else {
                    g.selectAll('text').attr('class', 'text-gray-1')
                }
            })
            .call((g) => {
                if(!yAxisLines) {
                    g.selectAll('.tick line').remove()
                } else {
                    g.selectAll('.tick line')
                    .attr("x2", width - marginLeft)
                    .attr("stroke-opacity", 0.2)
                }
            });

        
        /* Add tooltip line and circle dot */
        const bisect = d3.bisector(d => d.Date).center;
        
        /* Create tooltip hover area */
        const toolTip = svg
            .append("g")
            .classed("mouse", true)
            .style("display", "none");

        /* Add line */
        toolTip
            .append("line")
            .attr("x", -1)
            .attr("y2", (height - marginBottom) - marginTop)
            .attr("stroke", strokeColor)
            .attr('stroke-dasharray', '4,4')
            .attr("transform", `translate(${0},${marginTop})`);
        
        /* Add dot */
        toolTip
            .append("circle")
            .attr("r", 3)
            .attr("fill", '#fff')
            .attr("stroke", strokeColor);

        /* Add text */
        toolTip
            .append("text")
            .attr('class', 'text-xs font-bold')
            .attr("transform", `translate(${0},${marginTop / 2})`);
        
        /* Add hover event listener */
        svg.on("mouseover", function () {
            toolTip.style("display", "block");
        });

        /* Add mouse move event lister */
        svg.on("mousemove", function (mouse) {
            const [xCord]     = d3.pointer(mouse, this);
            const i           = bisect(aapl, x.invert(xCord));
            const currentData = aapl[i];

            if(!currentData) return ;// prevent if no data;

            toolTip.attr("transform", `translate(${x(currentData.Date)},${0})`);

            toolTip
                .select("text")
                .text(`${Math.ceil(currentData.count)}`)
                .attr(
                    "text-anchor", "middle"
                );

            toolTip.select("circle")
            .attr("cy", y(currentData.count));
        });

        /* Add mouseout event listener */
        svg.on("mouseout", function () {
            toolTip.style("display", "none");
        });
    
        return svg.node();
      };
    

    /**
     * Doughnut chart
     * @memberof Charts
     * @param {Object} Options Options (width, height, margin, data, valueColor, textColor, textSize, centerText, radius, radiusWidth, placeholderColor)
     */
    static doughnutChart({
        width            = 50,
        height           = 50,
        margin           = 5,
        data             = { a: 100, b: 0 },
        valueColor       = '#000',
        placeholderColor = '#F8F9FC',
        textColor        = null,
        textSize         = 12,
        centerText       = true,
        centerTextValue  = null,
        radius           = null,
        radiusWidth      = 5

    }      = {}) {


        // The radius of the pieplot is half the width or half the height (smallest one). I subtract a bit of margin.
        radius = radius ?? Math.min(width, height) / 2 - margin;

        // append the svg object to the div called 'my_dataviz'
        const svg = d3
        .create('svg')
        .attr('viewBox', [0, 0, width, height])
        .attr('width', width)
        .attr('height', height)
        .attr('style', 'max-width: 100%; height: auto; height: intrinsic; ')
        .style('-webkit-tap-highlight-color', 'transparent')
        .style('overflow', 'visible');

        const mainG = svg
        .append('g')
        .attr('transform', `translate(${width / 2},${height / 2})`);


        // set the color scale
        const color = d3.scaleOrdinal().range([placeholderColor, valueColor]);

        // Compute the position of each group on the pie:
        const pie = d3.pie().value((d) => d[1]);

        const data_ready = pie(Object.entries(data));

        /*  Add center text */
        const centerY = height / 2;
        const textY = textSize / 2.5;

        console.log('chart data', data)

        

        if(centerText) {
            centerTextValue = centerTextValue || `${data.b}%`;
            
            mainG
            .append('g')
            .attr('text-anchor', 'middle')
            .append('text')
            .attr('transform', `translate(0, ${centerY -  (centerY - textY)})`)
            .text(centerTextValue)
            .attr('fill', textColor ?? valueColor)
            .attr('font-size', textSize)
            .attr('class', 'font-semibold ');
        }

        // Build the pie chart: Basically, each part of the pie is a path that we build using the arc function.
        mainG
        .selectAll('whatever')
        .data(data_ready)
        .join('path')
        .attr('d',d3
            .arc()
            .innerRadius(radius + radiusWidth) // This is the size of the donut hole
            .outerRadius(radius)
            .cornerRadius(d => {
                return d.index == 1 ? 0 : 30;
            })
        )
        .attr('fill', (d) => color(d.data[0]));


        return svg.node();
    }
}